import React, { useState, useEffect } from 'react'
import axios from 'axios'
import MessageBox from '../../components/CommonComponents/MessageBox'
import { useMyContext } from '../../components/Provider/CommonProvider'
import { Link, useParams } from 'react-router-dom'
import { TagsInput } from "react-tag-input-component";
import FormContainer from '../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../components/CommonComponents/Wrapper'
import AdminVideoPlayer from '../../components/CommonComponents/AdminVideoPlayer'
import RightWrapper from '../../components/CommonComponents/RightWrapper'
import MessageLabel from '../../components/CommonComponents/MessageLabel'
import AdminCustomInput from '../../components/CommonComponents/AdminCustomInput.jsx'
import { useRef } from 'react'
import AdminSaveHeader from '../../components/CommonComponents/AdminSaveHeader.jsx'
import AdminCustomURLCopy from '../../components/CommonComponents/AdminCustomURLCopy.jsx'
import AdminCustomButton from '../../components/CommonComponents/AdminCustomButton.jsx'
import { toast } from 'react-toastify'
import Response_Processing from '../../layout/Others/Response_Processing.js'
import AdminBackNavigation from '../../components/CommonComponents/AdminBackNavigation.jsx'
import Defaultloadinggif from '../../layout/Others/Defaultloadinggif.js';
import { connect } from 'react-redux';
import { LuClock, LuPlus } from "react-icons/lu";
import { CiCalendarDate } from "react-icons/ci";
import { BsDatabase, BsFileEarmarkBreak, BsPlusCircle } from "react-icons/bs";
import AdminAudioPlayer from '../../components/CommonComponents/AdminAudioPlayer.jsx';
import SiteStorage from './SiteStorage.jsx';
import BunnyStorage from './BunnyStorage.jsx';
import VideoCipherStorage from './VideoCipherStorage.jsx';
import AdminCustomSelect from '../../components/CommonComponents/AdminCustomSelect.jsx'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import { IoClose } from 'react-icons/io5'
import StorageLimitModal from '../../components/CommonComponents/StorageLimitModal.jsx'
import AdminMiniPlayer from '../../components/CommonComponents/AdminMiniPlayer.jsx';
import AdminGalleryModal from '../../components/CommonComponents/AdminGalleryModal';
import AdminYoutubePlayer from '../../components/CommonComponents/AdminYoutubePlayer';
import AdminProcessButton from '../../components/CommonComponents/AdminProcessButton';
const LibraryManage = ({ storageSetting, storageLoading, siteTheme, storageSettingError, adminSetting }) => {
    const { fetchRequest, fileResponse, clearFileResponse, handleFileChangeProvider } = useMyContext()
    const { id } = useParams()
    const baseURL = process.env.REACT_APP_Baseurl

    const editApi = `${baseURL}/admin/library/preview`
    const updateApi = `${baseURL}/admin/library/update`
    const trailerApiLibrary = `${baseURL}/admin/library/upload?upload_type=trailer&clone_to=library&action_type=updated`
    const assingAPI = `${baseURL}/admin/library/assignto`

    const [formData, setFormData] = useState({
        state: "formData",
        cdn_url: [],
        error: null,
        upload_single: "0"
    })

    const sourceType = {
        '1': 'Video',
        '5': "Audio",
        '16': "Trailer",
        '17': "substitute"
    }

    const accessOptions = ['free', 'ppv', 'subscription', 'registered']

    const [formDataError, setFormDataError] = useState({})
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [loading, setLoading] = useState(false)
    const [defaultOption, setDefaultOption] = useState({ trailerOption: [] })
    const [galleryModal, setGalleryModal] = useState(false)
    const [galleryModalSourceFillter, setGalleryModalSourceFillter] = useState(null)
    const [selectedIds, setSelectedIds] = useState([])
    const [transcodingEnabled, setTranscodingEnabled] = useState(true);
    const [hideTranscodingBanner, setHideTranscodingBanner] = useState(false);
    const combinedRef = useRef({
        title: null,
    });

    const [shareUrl, setShareUrl] = useState('');
    const [showStorageModal, setShowStorageModal] = useState(false);
    const [tagsList, setTagsList] = useState([]);
    const [tagLoading, setTagLoading] = useState(false);
    useEffect(() => {
        if (fileResponse === 413) {
            setShowStorageModal(true);
        }
    }, [fileResponse]);

    const handleStorageModalClose = () => {
        setShowStorageModal(false);
        clearFileResponse();
    };

    const access_token = localStorage.getItem("access_token");
    const role = localStorage.getItem("role");
    const headers = {
        "Content-Type": "application/json", Authorization: "Bearer " + access_token,
        Accept: "application/json", "Access-Control-Allow-Origin": "*",
    };

    const productTypeFromEnv = process.env.REACT_APP_DEPLOYMENT_PRODUCT_TYPE;

    let productType;

    if (productTypeFromEnv && productTypeFromEnv !== "null" && productTypeFromEnv !== "undefined") {
        productType = productTypeFromEnv;
    } else {
        productType = adminSetting?.productType;
    }

    // const uvfContainerRef = useRef(null); // No longer needed with WebPlayerView component

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;

        if (name == "free_duration") {
            const formattedInput = value.replace(/\D/g, "");

            const formattedTime = formattedInput
                .replace(/^(\d{2})(\d{2})(\d{2})$/, "$1:$2:$3")
                .substr(0, 8);

            setFormData((prev) => ({
                ...prev,
                [name]: formattedTime,
            }));

            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            return
        }

        if (type === 'text' || type == 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'number') {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }))
            setFormDataError((prev) => ({
                ...prev,
                [name]: ''
            }))
        }
    };

    const fetchTags = async () => {
        try {
            const response = await axios.get(`${baseURL}/admin/library/tags`, { headers });
            if (response.data.status) {
                setTagsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching tags:", error);
        }
    };

    const handleTagsChange = (newTags) => {
        // Split comma-containing entries (typed or pasted) into separate tags.
        const cleanedTags = (newTags || [])
            .flatMap((tag) => String(tag ?? "").split(","))
            .map((tag) => tag.trim())
            .filter((tag) => tag !== "")
            .filter((value, index, self) => self.indexOf(value) === index);
        setFormData(prev => ({
            ...prev,
            library_tag: cleanedTags
        }));
    };

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.title) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                title: "Title cannot be empty.",
            }));
            combinedRef.current['title'].focus()
            formIsValid = false;
        }

        if (formData?.access == 'ppv' && !formData?.price) {
            setFormDataError((prev) => ({
                ...prev,
                price: 'PPV price cannot be empty'
            }))
            combinedRef.current['price'].focus()
            formIsValid = false;
        }

        return formIsValid;
    }

    const handleUpdate = async () => {
        setShowOverlay(true);

        const payload = {
            title: formData?.title,
            access: formData?.access === "" ? null : formData?.access,
            free_duration: formData?.access == 'free' ? null : formData?.free_duration,
            price: formData?.price ?? null,
            trailer_type: formData?.trailer_type,
            trailer_mp4_url: formData?.trailer_type === 'mp4_url' ? formData?.trailer_mp4_url : null,
            trailer_m3u8_url: formData?.trailer_type === 'm3u8_url' ? formData?.trailer_m3u8_url : null,
            trailer_embed_code: formData?.trailer_type === 'embed_code' ? formData?.trailer_embed_code : null,
            library_tag: Array.isArray(formData?.library_tag) ? formData.library_tag.join(',') : (formData?.library_tag ?? null)
        }

        fetchRequest({
            method: 'PATCH',
            url: `${updateApi}/${id}`,
            params: {},
            data: payload,
        })
            .then(response => {
                const result = response
                if (result?.status) {
                    toast.success(result?.message)
                    setWithOutRefresh(!withOutRefresh)
                }
            })
            .catch(error => {
                const errorMessage = error?.response?.data?.message || error?.message
                toast.error(errorMessage + error?.response?.data?.error)
            }).finally(() => {
                setShowOverlay(false);
            })

    }

    const handleLibraryChange = async (e, name) => {
        const files = e.target.files;
        if (!files?.length) return;
        if (name === "trailer") {
            await handleFileChangeProvider(e, `${trailerApiLibrary}&video_id=${id}`, "trailer");
        }
    }

    const handleToggleGalleryModel = (val) => {
        setGalleryModal(prev => !prev)
        if (val === "clear") setSelectedIds([])
        setGalleryModalSourceFillter(val)
    }

    const handleCheckboxChange = (selectedId) => {
        setSelectedIds([selectedId])
    }

    const handleMoveVideo = async (selectIds) => {
        try {
            const response = await axios.post(
                `${assingAPI}?library_id=${id}&trailer_library_id=${selectIds?.[0]}`,
                {},
                { headers }
            )
            const result = response?.data
            if (result?.status) {
                toast.success(result?.message)
                setSelectedIds([])
                handleToggleGalleryModel()
                setWithOutRefresh(prev => !prev)
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message)
        }
    }

    const handleStore = (e) => {
        e.preventDefault()
        if (id) {

            if (formValidation()) {
                handleUpdate()
            }
            else {
                console.table("validation")
            }
        }
    }

    useEffect(() => {
        if (id) {
            fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    toast.success(response?.message)
                    const result = response
                    const updatedList = result?.data
                    if (updatedList?.library_tag) {

                        updatedList.library_tag = updatedList.library_tag.split(',').filter(tag => tag.trim() !== "");
                    } else {
                        updatedList.library_tag = [];
                    }
                    setFormData(updatedList)
                    setShareUrl(`${process.env.REACT_APP_Baseurl_Backend}/nexs-player/${updatedList?.slug}`)
                    if (result?.trailer_type && Array.isArray(result?.trailer_type)) {
                        setDefaultOption(prev => ({ ...prev, trailerOption: result?.trailer_type }))
                    }
                })
                .catch(error => {
                    toast.error(error?.response?.data?.message || error.message)
                    setFormData((prev) => ({
                        ...prev,
                        error: error?.response?.data?.error || error?.response?.data?.message
                    }))
                }).finally(() => {
                    setLoading(false)
                })
        }
        fetchTags();
    }, [id, withOutRefresh])


    // Fetch transcoding status (from setup-progress API)
    useEffect(() => {
        let cancelled = false;
        const fetchTranscodingStatus = async () => {
            try {
                const resp = await axios.get(`${baseURL}/admin/setup-progress`, { headers });
                const enabled = !!resp?.data?.data?.progress?.transcoding;
                if (!cancelled) setTranscodingEnabled(enabled);
            } catch (e) {
                // fail silently; keep default true to avoid blocking UI
            }
        };
        fetchTranscodingStatus();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseURL]);




    // NOTE: Replaced imperative WebPlayer initialization with declarative WebPlayerView component
    // The player is now rendered directly in JSX below (see WebPlayerView component)

    /*
    // OLD: Initialize unified-video-framework player alongside Video.js player
    useEffect(() => {
        let player = null;
        let cancelled = false;

        const st = Number(formData?.source_type);
        const isVideoType = (st === 1 || st === 16 || st === 17);
        const shouldInit = (productType === 'video_library') && isVideoType && formData?.type !== 'videocipher' && formData?.video_url;

        // Clear container early if we shouldn't init
        if (!shouldInit) {
            if (uvfContainerRef.current) {
                uvfContainerRef.current.innerHTML = '';
            }
            return;
        }

        const toUVFType = (format, url) => {
            const f = (format || '').toLowerCase();
            const u = (url || '').toLowerCase();
            if (f.includes('mpegurl') || u.endsWith('.m3u8')) return 'hls';
            if (f.includes('dash') || u.endsWith('.mpd')) return 'dash';
            if (f.includes('mp4') || u.endsWith('.mp4')) return 'mp4';
            if (f.includes('webm') || u.endsWith('.webm')) return 'webm';
            return 'auto';
        };

        const init = async () => {
            try {
                const framework = await import('unified-video-framework/web').catch(() => null);
                if (!framework || !framework.WebPlayer || !uvfContainerRef.current || cancelled) return;

                player = new framework.WebPlayer();
                await player.initialize(uvfContainerRef.current, {
                    autoPlay: false,
                    controls: true,
                    muted: false,
                    volume: 0.8,
                    playsInline: true,
                    debug: false,
                    showFrameworkBranding: false,
                    settings: { subtitles: false, speed: false, quality: true },
                    watermark: { text: 'Preview', position: 'top-right', opacity: 0.5 }
                });

                await player.load({
                    url: formData?.video_url,
                    type: toUVFType(formData?.video_format, formData?.video_url),
                    metadata: { title: formData?.title }
                });
            } catch (err) {
                console.error('Unified Video Framework init failed:', err);
                // Fallback to native HTML5 video element in the same container
                if (uvfContainerRef.current) {
                    uvfContainerRef.current.innerHTML = '';
                    const video = document.createElement('video');
                    video.src = formData?.video_url || '';
                    video.controls = true;
                    video.style.width = '100%';
                    video.style.height = '100%';
                    uvfContainerRef.current.appendChild(video);
                }
            }
        };

        init();

        return () => {
            cancelled = true;
            if (player && typeof player.destroy === 'function') {
                try { player.destroy(); } catch (e) { /* noop * / }
            }
            if (uvfContainerRef.current) {
                uvfContainerRef.current.innerHTML = '';
            }
        };
    }, [productType, formData?.video_url, formData?.video_format, formData?.title, formData?.source_type, formData?.type]);
    */

    if (loading) {
        return <Defaultloadinggif className="heightOnLoader" />
    }
    if (formData?.error) {
        return <MessageBox text={`Error : ${formData?.error}`} classname={`warningColor text-center my-5 d-block`} />
    }

    return (
        <div>
            {storageSetting?.site_storage === 1 && <StorageLimitModal open={showStorageModal} onClose={handleStorageModalClose} />}
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation path="/library" text='Back' />

            {(!transcodingEnabled && !hideTranscodingBanner) && (
                <div className="alert alert-warning d-flex align-items-center justify-content-between mt-2">
                    <div className="d-flex align-items-center">
                        <IoIosInformationCircleOutline size={20} className="me-2" />
                        <div>
                            <div className="fw-semibold">Enable Transcoding for seamless uploads</div>
                            <small className="text-muted">Turn on transcoding to ensure smooth processing and playback of uploaded videos.</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Link
                            to="/site/transcoding-setting"
                            className="link-primary fw-semibold text-decoration-underline"
                        >
                            Go to Transcoding Settings
                        </Link>


                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setHideTranscodingBanner(true)} aria-label="Dismiss">
                            <IoClose />
                        </button>
                    </div>
                </div>
            )}

            {((Number(storageSetting?.site_storage) === 1 || Number(storageSetting?.aws_storage) === 1 || Number(storageSetting?.bunnyCdnStorage) === 1 || Number(storageSetting?.sftp_storage) === 1) && !id) && <SiteStorage siteTheme={siteTheme} adminSetting={adminSetting} />}
            {/* {(storageSetting?.videocipher_storage === 1 && !id) && <VideoCipherStorage />} */}

            {id ?
                <>
                    <AdminSaveHeader heading="Preview and Edit" saveText="update" hideButton saveMethod={handleStore} />
                    <FormContainer>
                        <LeftWrapper>
                            <Wrapper>
                                <MessageLabel text={"Title"} className="mandatorySimple" />
                                <AdminCustomInput type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} error={formDataError?.title} id={"libraryButton"} />
                                {formData?.slug && productType == 'video_library' && <AdminCustomURLCopy link={shareUrl} fieldName={"Player URL"} className="copy-board-input position-relative " labelClassName="mt-md-2" />}
                                {formData?.m3u8_url && productType != 'video_library' && <AdminCustomURLCopy link={formData?.m3u8_url} fieldName={"HLS URL"} className="copy-board-input" labelClassName="mt-md-2" />}
                                {formData?.mp4_url && productType != 'video_library' && <AdminCustomURLCopy link={formData?.mp4_url} fieldName={"URL"} className="copy-board-input" labelClassName="mt-md-2" />}
                                {formData?.mp3_url && productType != 'video_library' && <AdminCustomURLCopy link={formData?.mp3_url} fieldName={"MP3 URL"} className="copy-board-input" labelClassName="mt-md-2" />}

                                 <div className="mt-4">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <MessageLabel text={"Tags"} />
                                    </div>
                                    <div className="mt-2">
                                        <TagsInput 
                                            id="library-tag" 
                                            name="library_tag" 
                                            value={Array.isArray(formData?.library_tag) ? formData.library_tag : []}
                                            separators={["Enter", ","]}
                                            onChange={handleTagsChange}
                                            classNames={{ tag: "custom-search-tag", input: "w-100" }}
                                            placeHolder="Type tag and press enter"
                                        />
                                    </div>
                                    {/* Displaying available tags from the database for reference */}
                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                        {tagsList?.map((tag, idx) => (
                                            <span 
                                                key={idx} 
                                                className="badge border text-primary bg-light cursor-pointer"
                                                onClick={() => {
                                                    const currentTags = Array.isArray(formData.library_tag) ? formData.library_tag : [];
                                                    if (!currentTags.includes(tag.name)) {
                                                        handleTagsChange([...currentTags, tag.name]);
                                                    }
                                                }}
                                            >
                                                {tag.name}
                                            </span>
                                        ))}
                                    </div>
                                </div>

                                {productType == 'video_library' &&
                                    <div className='mt-4'>
                                        <MessageLabel text={"Video access"} />
                                        <AdminCustomSelect id="video-access" name="access" value={formData?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={accessOptions?.map((item) => ({ name: item, value: item }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} />
                                    </div>
                                }
                                {productType == 'video_library' && (formData?.access == 'ppv') &&
                                    <div className='mt-4'>
                                        <MessageLabel text={"Please enter PPV price"} />
                                        <AdminCustomInput id={"ppv-price"} ref={(el) => (combinedRef.current.price = el)} type="number" name="price" value={formData?.price} onChange={handleInput} placeHolder={"Enter ppv price"} error={formDataError?.price} />
                                    </div>
                                }
                                {productType == 'video_library' && (formData?.access == 'ppv' || formData?.access == 'registered' || formData?.access == 'subscription') &&
                                    <div className='mt-4'>
                                        <MessageLabel text={"Free duration"} />
                                        <AdminCustomInput id={"video-free-duration-time"} ref={(el) => (combinedRef.current.free_duration = el)} type="text" maxLength="6" name="free_duration" value={formData?.free_duration} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.free_duration} />
                                    </div>
                                }
                                {defaultOption?.trailerOption?.length > 0 && Number(formData?.source_type) === 1 &&
                                    <div className='mt-4'>
                                        <MessageLabel text={"Trailer"} />
                                        <AdminCustomSelect
                                            id="library-trailer-type"
                                            name="trailer_type"
                                            value={formData?.trailer_type}
                                            onChange={handleInput}
                                            options={defaultOption?.trailerOption?.map((item) => ({ name: item?.name, value: item?.trailer_type }))}
                                            error={formDataError?.trailer_type}
                                            defaultOptionName={"Choose trailer type"}
                                        />
                                        {formData?.trailer_type === "mp4_video_upload" &&
                                            <>
                                                <input type="file" className="form-control mt-2" name="trailer" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" onChange={(e) => handleLibraryChange(e, "trailer")} />
                                                <AdminCustomButton saveMethod={() => handleToggleGalleryModel(16)} saveText="Choose from library" className="mt-2" />
                                            </>
                                        }
                                        {formData?.trailer_type === "m3u8_url" &&
                                            <AdminCustomInput type="text" name="trailer_m3u8_url" value={formData?.trailer_m3u8_url} onChange={handleInput} placeHolder={"Please enter trailer m3u8 url"} error={formDataError?.trailer_m3u8_url} />
                                        }
                                        {formData?.trailer_type === "mp4_url" &&
                                            <AdminCustomInput type="text" name="trailer_mp4_url" value={formData?.trailer_mp4_url} onChange={handleInput} placeHolder={"Please enter trailer mp4 url"} error={formDataError?.trailer_mp4_url} />
                                        }
                                        {formData?.trailer_type === "embed_code" &&
                                            <AdminCustomInput type="text" name="trailer_embed_code" value={formData?.trailer_embed_code} onChange={handleInput} placeHolder={"Please enter trailer embed code"} error={formDataError?.trailer_embed_code} />
                                        }
                                        {formData?.trailer_format_type != null &&
                                            <>
                                                <MessageLabel text={`Active Trailer Type : ${formData?.trailer_type?.replace(/_/g, " ") === "transcoding video" || formData?.trailer_type?.replace(/_/g, " ") === "m3u8 url" ? "HLS" : formData?.trailer_type?.replace(/_/g, " ")}`} className={"mb-sm-3 mt-3"} />
                                                <div className="adminVideoPlayer playerHeight vjs-16-9">
                                                    {formData?.trailer_format_type === "embed_code"
                                                        ? <AdminYoutubePlayer src={formData?.trailer_url} />
                                                        : (formData?.trailer_type === "transcoding_video" && !formData?.trailer_m3u8_url)
                                                            ? <AdminProcessButton cell="PROCESS" row={{ ...formData }} />
                                                            : <AdminMiniPlayer url={formData?.trailer_url || formData?.trailer_mp4_url || formData?.trailer_m3u8_url} videoFormat={formData?.trailer_format_type} title={formData?.title ? `${formData.title} - Trailer` : ''} poster={formData?.default_image} className="playerHeight" />
                                                    }
                                                </div>
                                                {(formData?.trailer_url || formData?.trailer_mp4_url || formData?.trailer_m3u8_url) && formData?.trailer_format_type !== "embed_code" && !(formData?.trailer_type === "transcoding_video" && !formData?.trailer_m3u8_url) &&
                                                    <AdminCustomURLCopy link={formData?.trailer_url || formData?.trailer_mp4_url || formData?.trailer_m3u8_url} fieldName={""} className="copy-board-input" />
                                                }
                                            </>
                                        }
                                    </div>
                                }
                            </Wrapper>
                        </LeftWrapper>
                        <RightWrapper>
                            <Wrapper>
                                {formData?.soft_delete == 1 ?
                                    <MessageBox classname={"warningColor d-block mb-3 "} text={`Note: This file will be permanently deleted on ${formData?.deleted_on} and cannot be recovered after that date.`} /> : ""}
                                {formData?.type == "videocipher" && <>

                                    {
                                        <table className='w-100 '>
                                            <tr>
                                                <th className='w-50 p-3   theme-border-secondary'>Resolution</th>
                                                <th className='w-50 p-3  theme-border-secondary'>Video Cipher Id</th>
                                            </tr>
                                            {formData?.resolutions?.split(",")?.map((item) => {
                                                return <tr>
                                                    <td className='p-3  theme-border-secondary'>{item}</td>
                                                    <td className='p-3  theme-border-secondary'> {formData?.[`videoId_${item?.toUpperCase()}`]}</td>
                                                </tr>

                                            })}
                                        </table>
                                    }

                                </>}
                                {([1, 16, 17].includes(Number(formData?.source_type))) && <>
                                    {formData?.type !== "videocipher" && productType !== 'video_library' &&
                                        <>
                                            <AdminMiniPlayer
                                                url={formData?.video_url}
                                                videoFormat={formData?.video_format}
                                                title={formData?.title}
                                                poster={formData?.default_image}
                                                className="playerHeight"
                                            />
                                            {formData?.video_url && <AdminCustomURLCopy link={formData?.video_url} fieldName={""} className="mt-2 copy-board-input" />}
                                        </>
                                    }
                                    {formData?.type !== "videocipher" && productType == 'video_library' &&
                                        <div className='mt-3'>
                                            <MessageLabel text="Unified Player (Web)" />
                                            <AdminMiniPlayer
                                                url={formData?.video_url}
                                                videoFormat={formData?.video_format}
                                                title={formData?.title}
                                                poster={formData?.default_image}
                                                className="adminVideoPlayer rounded-4"
                                                watermark={{
                                                    text: 'Preview',
                                                    position: { x: 'right', y: 'top' },
                                                    style: { opacity: 0.5 }
                                                }}
                                            />
                                            {formData?.video_url && <AdminCustomURLCopy link={formData?.video_url} fieldName={""} className="mt-2 copy-board-input" />}
                                        </div>
                                    }

                                    <div className='d-flex justify-content-between align-items-center flex-wrap px-3 pt-2'>
                                        {formData?.type !== "videocipher" && <div className="d-flex align-items-center gap-2">
                                            <LuClock style={{ width: "18px", height: "18px" }} /><MessageBox text={formData?.duration || "00:00:00"} />
                                        </div>}
                                        <div className="d-flex align-items-center gap-2">
                                            <CiCalendarDate style={{ width: "18px", height: "18px" }} /><MessageBox text={formData?.upload_on || "NA"} />
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <BsDatabase style={{ width: "18px", height: "18px" }} /><MessageBox text={['bunny_stream', 'bunny_storage'].includes(formData?.uploaded_type) ? 'CDN' : (formData?.uploaded_type?.replace(/_/g, " ") || "NA")} />
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <BsFileEarmarkBreak style={{ width: "18px", height: "18px" }} /><MessageBox text={sourceType[formData?.source_type] || "NA"} />
                                        </div>
                                    </div>

                                    {(formData?.type == "transcoding_video" || formData?.type == "m3u8_url") ?
                                        formData?.resolutions?.length ? <div className='mt-4'>
                                            <MessageLabel text="Video Resolution" />
                                            <div className=' d-flex align-items-center gap-3'>
                                                {formData?.resolutions?.split(",").map((item) => <span className='custom-input-border  px-2 py-1 rounded-2'>{item}</span>)}
                                            </div>
                                        </div> : "" : ""}
                                </>}
                                {Number(formData?.source_type) === 5 && <AdminAudioPlayer data={formData} />}

                            </Wrapper>
                        </RightWrapper>
                        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update"} />

                    </FormContainer>
                </>
                : ""}

            {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={galleryModalSourceFillter} saveAction={handleMoveVideo} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={galleryModalSourceFillter === 16 ? "Select Trailer" : "Select"} />}
        </div >
    )
}
const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
    storageSettingError: state.storageSetting.error,
    storageLoading: state.storageSetting.loading,
    siteTheme: state.siteTheme.siteTheme,
    adminSetting: state.siteTheme.adminSetting
});
export default connect(mapStateToProps)(LibraryManage)